import { zodTransformFirestoreTimestampToDate } from "../utils/zodUtils.mjs";
import { zodFlavorId } from "./ids.mjs";
import { defineFirestoreCollection } from "./firebaseCollectionSchema.mjs";
import { PiiCategory, meta } from "./meta.mjs";
import { z as z$1 } from "zod";

// src/models/subscriptionSchedule.ts
const subscriptionScheduleStatusSchema = z$1.enum([
	"draft",
	"pending",
	"activated",
	"cancelled",
	"failed"
]);
const subscriptionScheduleSchema = z$1.object({
	id: zodFlavorId(),
	customerId: zodFlavorId(),
	selectedProductId: zodFlavorId(),
	selectedProductName: z$1.string().nullable().optional(),
	stripeSubscriptionStartDate: z$1.any().optional().transform((v) => v == null || v === void 0 ? void 0 : zodTransformFirestoreTimestampToDate(v)),
	status: subscriptionScheduleStatusSchema,
	stripeCheckoutSessionId: meta(z$1.string().nullable().optional(), { pii: { category: "identifier" } }),
	stripeSubscriptionId: meta(z$1.string().nullable().optional(), { pii: { category: "identifier" } }),
	stripeSubscriptionScheduleId: meta(z$1.string().nullable().optional(), { pii: { category: "identifier" } }),
	createdAt: z$1.any().transform(zodTransformFirestoreTimestampToDate).optional(),
	updatedAt: z$1.any().transform(zodTransformFirestoreTimestampToDate).optional()
});
/**
* Subscription schedule collection — sponsored customer self-pay handoff state.
* Path: subscription_schedules/{customerId}
*/
const SubscriptionSchedules = defineFirestoreCollection("subscription_schedules", subscriptionScheduleSchema, void 0, {
	dwReplication: true,
	firestoreCollectionPath: "subscription_schedules"
});

export { SubscriptionSchedules, subscriptionScheduleSchema, subscriptionScheduleStatusSchema };
//# sourceMappingURL=subscriptionSchedule.mjs.map